import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthUser } from '../../states/user.atom';
import { rbac } from '../../permissions/permissions';
import ErrorFallback from '../common/ErrorFallback';
import { StopOutlined } from '@ant-design/icons';

export interface WithPermissionCheckProps {
  requiredPermission: string;
}

export const WithPermissionCheck = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  requiredPermission: string
) => {
  // Create a new component that will handle the permission check
  const PermissionCheckedComponent: React.FC<P> = (props) => {
    const { t } = useTranslation();
    const { getUserPermissions, isSysAdmin } = useAuthUser();
    const userPermissions = getUserPermissions();

    if (!rbac.hasAccess(userPermissions, requiredPermission) && !isSysAdmin()) {
      return (
        <ErrorFallback
          error={new Error('You are not authorized to view this page')}
          resetErrorBoundary={() => {}}
          message={t('common.unauthorized')}
          details={t('common.unauthorizedDetails')}
          showResetButton={false}
          icon={<StopOutlined />}
          resetText={t('common.back')}
        />
      );
    }

    return <WrappedComponent {...props} />;
  };

  return PermissionCheckedComponent;
};
